import { toast } from "react-toastify";
import classes from "../TrucksAvailable.module.css";
import ReactTooltip from "react-tooltip";
import Select from "react-select/creatable";
import EditEnquiry from "./EditEnquiry/editenquiry";
import MoveToIndent from "../MoveToIndent/MoveToIndent";
import { DateFormatter1 } from "../../../Constants";
import { titleCase } from "../../../Utility";
import UpgradeModal from "../../UpgradeModal/UpgradeModal";
import TenurePremiumModal from "./TenurePremiumModal";
import TenureSelectOption from "./TenureSelectOption";
import ViewLsp from "./ViewLSP";
import Summary from "./Summary/Summary";
import "./NewEnquiry.css";
import CancelEnquiry from "./CancelEnquiry";
import ViewEnquiry from "./ViewEnquiry";
import Modal from "../../Shared/PopupModal/PopupModal";
import ControlledModal from "../../Shared/PopupModal/ControlledPopupModal/ControlledPopupModal";
import ShortlistLisp from "./ShortlistLsp";
import NewPlacementDetails from "./PlacementDetails/NewPlacementDetails";
import { UserApiContext } from "../../UserDetailsContext/UserDetailsContext";
import { useContext, useState } from "react";

const MobileAddedLanes = ({
  resdata,
  getEnquiryApis,
  setNewSpot,
  newSpot,
  enquiryBucket,
  backbutton,
  discovernowbutton,
  planningbutton,
  send_data,
  cancelEnquiry,
  apply_Filter,
  filters_applied,
  visible_enquiry,
  skipactive,
  onInputChangeHandler,
  isPlacement,
  company_id,
  deleteHandler,
  transporterlistempty,
  getchecked,
  addrequest,
  isquotationcheck,
  getnegotiatedisaable,
  enquiryTransition,
  profile_view_count,
  autoPushIndent,
  ischat,
  filtered_details,
  setsend_data,
  TruckTypes,
  tenurelist,
  mastertransporterlist,

  isApprover,
  approvalType,
  getEnquiries,
  userid,
  companyProfileData,
  closeSummaryModal,
  reload_data,
  isIndent,
  closeIndentModal,
  profile_view_allowed,
  getStatus,
  expiredEnquiries,
  approveEnquiry,
  bucket,
  isRestricted,
  checkActionPermission,
  isSuperAdmin,
}) => {
  const { userDetails } = useContext(UserApiContext)
  var company_mail = userDetails?.email;
  const [showTenureUpgradeModal, setShowTenureUpgradeModal] = useState(false);

  const MAX_TRUCKS_REQUIRED = 100;

  const handleTruckRequiredInput = (event, item, index) => {
    const rawValue = event.target.value;
    const numericValue = Number(rawValue);
    if (rawValue !== "" && !Number.isNaN(numericValue) && numericValue > MAX_TRUCKS_REQUIRED) {
      event.target.value = String(MAX_TRUCKS_REQUIRED);
      toast.error(`Max truck required can be ${MAX_TRUCKS_REQUIRED}`);
      onInputChangeHandler("truck", String(MAX_TRUCKS_REQUIRED), item, index);
      return;
    }
    onInputChangeHandler("truck", rawValue, item, index);
  };
  const isApprovedBucket = bucket === "approved";

  /**
   * Gets today's date in YYYY-MM-DD format.
   * @returns {string} The current date formatted as YYYY-MM-DD.
   */
  var mindate = new Date();
  var day = ("0" + mindate.getDate()).slice(-2);
  var month = ("0" + (mindate.getMonth() + 1)).slice(-2);
  var year = mindate.getFullYear();
  var todaydate =
    year.toString() + "-" + month.toString() + "-" + day.toString() + "";

  return (
    <>
      {
        <div style={{ width: "100%" }}>
          {send_data && send_data.length > 0
            ? send_data.map((item, index) => (
                <div
                  className={classes["mobile-enquiry"]}
                  key={`enquiry${index}`}
                >
                  {!planningbutton ? (
                    <button
                      style={{ float: "right" }}
                      className="btn btn-sm btn-primary"
                      onClick={(e) => deleteHandler(e, item, index)}
                    >
                      <i className="fa fa-trash" style={{ color: "white" }}></i>
                    </button>
                  ) : null}
                  <div>
                    <b>Origin:</b>
                    {item.lane_details?.origin.location_name}
                  </div>
                  <div>
                    <b>Destination:</b>
                    {item.lane_details?.destination.location_name}
                  </div>
                  <div>
                    <b>Truck Type:</b>
                    {!discovernowbutton ? (
                      <>
                        {Array.isArray(item.lane_details?.truck_types) ? (
                          <>
                            {item.lane_details?.truck_types.map((trucks) => {
                              return (
                                <span key={trucks.value}>
                                  {trucks.label}&nbsp;
                                </span>
                              );
                            })}
                          </>
                        ) : (
                          item.lane_details?.truck_types.label
                        )}
                      </>
                    ) : (
                      <Select
                        options={TruckTypes}
                        isMulti={false}
                        onChange={(value) =>
                          onInputChangeHandler("truckType", value, item, index)
                        }
                        value={item.lane_details?.truck_types}
                        className={"Truck_Type_Select"}
                        classNamePrefix={"Truck_Prefix"}
                        defaultValue=""
                      />
                    )}
                  </div>
                  <div>
                    <div>
                      <b>No of Trucks:</b>
                    </div>
                    <div style={{ fontSize: "13px", width: "90%" }}>
                      <input
                        type="number"
                        min="1"
                        max="100"
                        style={{
                          fontSize: "13px",
                          height: "38px",
                          width: "100%",
                          margin: "0",
                        }}
                        defaultValue={
                          item.lane_details?.truck_required ? item.lane_details?.truck_required : ""
                        }
                        onInput={(event) =>
                          handleTruckRequiredInput(event, item, index)
                        }
                      />
                    </div>
                  </div>
                  <div>
                    <div>
                      <b>Date of Placement/Contract:</b>
                    </div>
                    {item.disabled ? (
                      <>
                        {DateFormatter1(item.lane_details?.due_date)}
                        <div style={{ fontSize: "12px", marginTop: "4px" }}>
                          {item?.lane_details?.dop_start_time ? `Start: ${item.lane_details?.dop_start_time}` : ""}
                          {item?.lane_details?.dop_end_time ? ` | End: ${item.lane_details?.dop_end_time}` : ""}
                        </div>
                      </>
                    ) : (
                      <>
                        <div style={{ fontSize: "13px", width: "90%", marginBottom: "6px" }}>
                          <input
                            type="date"
                            defaultValue={item.lane_details?.due_date}
                            min={todaydate}
                            style={{ height: "38px" }}
                            onInput={(e) =>
                              onInputChangeHandler(
                                "due",
                                e.target.value,
                                item,
                                index
                              )
                            }
                          />
                        </div>
                        <div style={{ display: "flex", gap: "8px" }}>
                          <input
                            type="time"
                            defaultValue={item?.lane_details?.dop_start_time || ""}
                            style={{ width: "50%", height: "32px", padding: "6px" }}
                            onInput={(e) =>
                              onInputChangeHandler(
                                "dop_start_time",
                                e.target.value,
                                item,
                                index
                              )
                            }
                          />
                          <input
                            type="time"
                            defaultValue={item?.lane_details?.dop_end_time || ""}
                            style={{ width: "50%", height: "32px", padding: "6px" }}
                            onInput={(e) =>
                              onInputChangeHandler(
                                "dop_end_time",
                                e.target.value,
                                item,
                                index
                              )
                            }
                          />
                        </div>
                      </>
                    )}
                  </div>
                  <div>
                    <div>
                      <b>Contract Tenure:</b>
                    </div>
                    <div>
                      <Select
                        options={tenurelist}
                        isMulti={false}
                        isOptionDisabled={(option) => option.isDisabled}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                        components={{
                          Option: TenureSelectOption(() =>
                            setShowTenureUpgradeModal(true),
                          ),
                        }}
                        formatOptionLabel={(option) =>
                          option.isDisabled ? (
                            <span>
                              {option.label}{" "}
                              <span style={{ color: "#f5a623", fontSize: "11px" }}>
                                (Premium)
                              </span>
                            </span>
                          ) : (
                            option.label
                          )
                        }
                        onChange={(value) => {
                          if (value?.isDisabled) {
                            setShowTenureUpgradeModal(true);
                            return;
                          }
                          onInputChangeHandler("tenure", value, item);
                        }}
                        value={item.lane_details?.contract_tenure ? item.lane_details?.contract_tenure : []}
                        className={"Truck_Type_Select"}
                        classNamePrefix={"Truck_Prefix"}
                      />
                    </div>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div>
                      <b>Shortlist Transporters:</b>
                    </div>
                    <Modal
                      buttonLabel={`Click Here`}
                      buttonClass={`btn btn-link ${classes["shortlist-button"]}`}
                      content={({ onClose }) => (
                        <ShortlistLisp
                          item={item}
                          setsend_data={setsend_data}
                          send_data={send_data}
                          idx={index}
                          onClose={onClose}
                        />
                      )}
                      title={`Shortlist Transporters`}
                      subtitle={`(This enquiry will be sent to the selected transporters)`}
                      id="closebutton"
                      screenName="LoRRI Spot"
                      moduleName="My Enquiries"
                      activityName={`View LSP Button clicked for ${item.lane_details?.origin.location_name} to ${item.lane_details?.destination.location_name}`}
                      backdrop={false}
                      style={{ fontSize: "13px", padding: "0 5%" }}
                    />
                  </div>
                  <div style={{ display: "flex" }}>
                    <div>
                      <b>Placement Details:</b>
                    </div>
                  </div>
                </div>
              ))
            : null}
          {send_data.length === 0 &&
            !transporterlistempty &&
            filtered_details &&
            filtered_details.length > 0 ? (
            filtered_details.map((item, index) => {
              const status = item.status || {};
              const isActive =
                !status.is_delete &&
                !status.is_expired &&
                !status.enquiry_closed &&
                !status.approved_status;
              const isCancelled = status.is_delete;
              const isArchived =
                status.is_expired ||
                (status.enquiry_closed && !status.approved_status);
              const isApproved =
                status.enquiry_closed && status.approved_status;

              return (
                <div
                  key={`enquiry${item.truck_enquiry_id}`}
                  className={classes["mobile-enquiry"]}
                  id={`enquiry${item.truck_enquiry_id}`}
                >
                  <div>
                    <input
                      type="checkbox"
                      checked={getchecked(item)}
                      onChange={(e) => addrequest(e, item, index)}
                      className={classes["mobile-enquiry-checkbox"]}
                    />
                  </div>
                  <div
                    style={{ display: "flex", justifyContent: "space-around" }}
                  >
                    <div
                      style={{
                        fontSize: "16px",
                        display: "flex",
                        justifyContent: "flex-end",
                        fontWeight: "600",
                        width: "125px",
                      }}
                    >
                      {item.lane_details?.origin ? (
                        <>
                          <i
                            className="fa fa-map-marker"
                            style={{ color: "#393186", marginRight: "1%" }}
                          />
                          <span
                            style={{ cursor: "pointer", paddingLeft: "5%" }}
                            data-tip
                            data-for={`origin${index}`}
                          >
                            {item.lane_details?.origin && item.lane_details?.origin.location
                              ? item.lane_details?.origin.location.location
                              : item.lane_details?.origin.location_name}
                          </span>
                          <ReactTooltip
                            id={`origin${index}`}
                            className={`${classes["tooltip"]}`}
                            place="bottom"
                            effect="solid"
                            scrollHide={true} delayHide={0}
                          >
                            {item.lane_details?.origin.location_name}
                          </ReactTooltip>
                        </>
                      ) : (
                        "NA"
                      )}
                      {/* {item.lane_details?.origin.location_name} */}
                    </div>
                    <i
                      className={`fa fa-arrow-right`}
                      style={{ margin: "0 1%", padding: "0 1%" }}
                    />
                    <div
                      style={{
                        fontSize: "16px",
                        display: "flex",
                        width: "125px",
                        fontWeight: "600",
                      }}
                    >
                      {item.lane_details?.destination ? (
                        <>
                          <i
                            className="fa fa-map-marker"
                            style={{ color: "#393186", marginRight: "1%" }}
                          />
                          <span
                            style={{ cursor: "pointer", paddingLeft: "5%" }}
                            data-tip
                            data-for={`destination${index}`}
                          >
                            {item.lane_details?.destination && item.lane_details?.destination.location
                              ? item.lane_details?.destination.location.location
                              : item.lane_details?.destination.location_name}
                          </span>
                          <ReactTooltip
                            id={`destination${index}`}
                            className={`${classes["tooltip"]}`}
                            place="bottom"
                            effect="solid"
                            scrollHide={true} delayHide={0}
                          >
                            {item.lane_details?.destination.location_name}
                          </ReactTooltip>
                        </>
                      ) : (
                        "NA"
                      )}
                    </div>
                    {(item.lane_details?.document_details || item.lane_details?.sales_invoice_number) && (
                      <div
                        style={{ fontSize: "12px", color: "#666", textAlign: "center", marginTop: "4px", cursor: "pointer" }}
                        title="Sales Invoice Number"
                      >
                        <b>SIR:</b> {item.lane_details.document_details || item.lane_details.sales_invoice_number}
                      </div>
                    )}
                  </div>
                  <div style={{ fontSize: "14px", textAlign: "center" }}>
                    {Array.isArray(item.lane_details?.truck_types) ? (
                      <>
                        {" "}
                        {item.lane_details?.truck_types.map((trucks) => {
                          return (
                            <span key={`${trucks.value}`}>
                              {trucks.label}&nbsp;
                              <br />
                            </span>
                          );
                        })}{" "}
                      </>
                    ) : (
                      item.lane_details?.truck_types.label
                    )}
                    {(item.lane_details?.tonnage || item.lane_details?.capacity || item.lane_details?.tonnage_unit) && (
                      <div style={{ fontSize: "12px", color: "#666", marginTop: "4px", textAlign: "center" }}>
                        <b>Weight:</b> {item.lane_details.tonnage || ""}{" "}
                        {item.lane_details.capacity || item.lane_details.tonnage_unit || ""}
                      </div>
                    )}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      padding: "2%",
                      justifyContent: "space-between",
                    }}
                  >
                    <span style={{ fontSize: "13px" }}>
                      <b>Username:</b>
                      {titleCase(item.email.split("@")[0])}
                    </span>
                    <span style={{ fontSize: "13px", display: "flex" }}>
                      <b>Date of Enquiry:</b>
                      {item.submission_date
                        ? DateFormatter1(item.submission_date)
                        : "NA"}
                    </span>
                  </div>
                  <div style={{ padding: "2%" }}>
                    <div style={{ fontSize: "13px" }}>
                      <b># Trucks:</b>
                      {item.lane_details?.truck_required && item.lane_details?.truck_required > 0
                        ? item.lane_details?.truck_required
                        : "NA"}
                    </div>
                    <div style={{ fontSize: "13px" }}>
                      <div style={{ display: "flex" }}>
                        <b>Date of Placement / Contract:</b>
                        {item.lane_details?.due_date ? DateFormatter1(item.lane_details?.due_date) : "NA"}
                      </div>
                      {(item.lane_details?.dop_start_time || item.lane_details?.dop_end_time) && (
                        <div style={{ fontSize: "12px", color: "#555", marginTop: "2px" }}>
                          {item.lane_details?.dop_start_time ? item.lane_details?.dop_start_time : "--"}{" "}
                          –{" "}
                          {item.lane_details?.dop_end_time ? item.lane_details?.dop_end_time : "--"}
                        </div>
                      )}
                    </div>
                  </div>
                  <div style={{ fontSize: "13px", padding: "2%" }}>
                    <b>Contract Tenure:</b>
                    {item.lane_details?.contract_tenure && item.lane_details?.contract_tenure.length > 0
                      ? item.lane_details?.contract_tenure[0].value
                      : "Spot Rates"}
                  </div>
                  <div style={{ fontSize: "13px", padding: "2%" }}>
                    <b>View Transporters:</b>
                    <Modal
                      buttonLabel={`Click Here`}
                      buttonClass="btn btn-link"
                      style={{ fontSize: "14px", padding: "0 2%" }}
                      content={
                        <ViewLsp
                          item={item}
                          planningbutton={planningbutton}
                          mastertransporterlist={mastertransporterlist}
                        />
                      }
                      title={`Shortlist Transporters`}
                      subtitle={
                        <div style={{ display: "flex", flexDirection: "column", gap: "6px", marginTop: "2px" }}>
                          {/* Route row */}
                          <div style={{ display: "flex", alignItems: "center", gap: "6px", flexWrap: "wrap" }}>
                            <span style={{ display: "inline-flex", alignItems: "center", gap: "4px", background: "#f0f4ff", border: "1px solid #c7d2f5", borderRadius: "6px", padding: "3px 9px", fontSize: "12px", color: "#393185", fontWeight: 600 }}>
                              <i className="fa fa-circle" style={{ fontSize: "7px", color: "#393185" }} />
                              {item.lane_details?.origin.location_name}
                            </span>
                            <i className="fa fa-long-arrow-right" style={{ color: "#393185", fontSize: "14px" }} />
                            <span style={{ display: "inline-flex", alignItems: "center", gap: "4px", background: "#f0f4ff", border: "1px solid #c7d2f5", borderRadius: "6px", padding: "3px 9px", fontSize: "12px", color: "#393185", fontWeight: 600 }}>
                              <i className="fa fa-map-marker" style={{ fontSize: "11px", color: "#e53935" }} />
                              {item.lane_details?.destination.location_name}
                            </span>
                          </div>
                          {/* Truck type row */}
                          <div>
                            <span style={{ display: "inline-flex", alignItems: "center", gap: "5px", background: "#393185", borderRadius: "6px", padding: "3px 10px", fontSize: "12px", color: "#fff", fontWeight: 500 }}>
                              <i className="fa fa-truck" style={{ fontSize: "11px" }} />
                              {Array.isArray(item.lane_details?.truck_types)
                                ? item.lane_details?.truck_types.map((t) => t.label).join(", ")
                                : item.lane_details?.truck_types?.label}
                            </span>
                          </div>
                        </div>
                      }
                      id="editenquiry"
                      screenName="LoRRI Spot"
                      moduleName="My Enquiries"
                      activityName={`View LSP Button clicked for ${item.lane_details?.origin.location_name} to ${item.lane_details?.destination.location_name}`}
                      backdrop={false}
                    />
                  </div>
                  <div className={classes["mobile-button-row"]}>
                    <div style={{ fontSize: "13px" }}>
                      {isquotationcheck ? (
                        <Modal
                          buttonLabel={
                            <div className="d-flex align-items-center">
                              <i
                                style={{ color: "white", fontSize: "14px" }}
                                className={`fa ${item?.status?.enquiry_closed === true &&
                                    item?.status?.approved_status === true
                                    ? "fa-certificate"
                                    : item?.status?.enquiry_closed === true &&
                                      item?.status?.approved_status === false
                                      ? "fa-exclamation-circle"
                                      : "fa-list-alt"
                                  }`}
                              />
                              <span style={{ marginLeft: "6px" }}>Quotation Summary</span>
                              {item?.transporter_list_count > 0 && (
                                <div className="ml-2">
                                  {item.transporter_list_count}
                                </div>
                              )}
                            </div>
                          }
                          buttonClass={`btn btn-sm ${item?.status?.enquiry_closed === true &&
                              item?.status?.approved_status === false
                              ? "btn-warning"
                              : item?.status?.enquiry_closed === true &&
                                item?.status?.approved_status === true
                                ? "btn-success"
                                : item?.transporter_list_count > 0
                                  ? "btn-success"
                                  : "btn-primary"
                            }`}
                          style={{
                            fontSize: "13px",
                            cursor: isRestricted ? "not-allowed" : "pointer",
                            opacity: isRestricted ? 0.6 : 1,
                          }}
                          content={
                            <Summary
                              transporter_list={item.transporter_list}
                              item={item}
                              enquiryTransition={enquiryTransition}
                              itemdisable={getnegotiatedisaable(item)}
                              profile_view_allowed={profile_view_count}
                              profile_view_count={profile_view_count}

                              isApprover={isApprover}
                              approval_type={approvalType}
                              userid={userid}
                              autoPushIndent={autoPushIndent}
                              companyProfile={companyProfileData}
                            />
                          }
                          title={`Quotation Summary`}
                          subtitle={
                            <div>
                              {item.lane_details?.origin.location_name} to{" "}
                              {item.lane_details?.destination.location_name},{" "}
                              {Array.isArray(item.lane_details?.truck_types)
                                ? item.lane_details?.truck_types
                                  .map((t) => t.label)
                                  .join(", ")
                                : item.lane_details?.truck_types.label}
                              {item.indent_created && (
                                <span style={{ fontWeight: "bolder" }}>
                                  {" "}
                                  -- (Moved to Indent)
                                </span>
                              )}
                            </div>
                          }
                          id="editenquiry"
                          size={"lg"}
                          screenName="LoRRI Spot"
                          moduleName="My Enquiries"
                          activityName={`View Quotation button clicked for ${item.lane_details?.origin.location_name} to ${item.lane_details?.destination.location_name}`}
                          buttonTitle={`You have received ${item.transporter_list &&
                              item.transporter_list.length > 0
                              ? item.transporter_list.length
                              : 0
                            } Quotation`}
                          onClose={closeSummaryModal}
                        />
                      ) : (
                        <UpgradeModal
                          screenName="LoRRI Spot"
                          moduleName="Upgrade Popup"
                          feature="View Quotation"
                          activityName={`View Quotation button clicked for ${item.lane_details?.origin.location_name} to ${item.lane_details?.destination.location_name}`}
                          buttonClass={`btn btn-sm ${item?.status?.enquiry_closed === true &&
                              item?.status?.approved_status === false
                              ? "btn-warning"
                              : item?.status?.enquiry_closed === true &&
                                item?.status?.approved_status === true
                                ? "btn-success"
                                : item?.transporter_list_count > 0
                                  ? "btn-success"
                                  : "btn-primary"
                            }`}
                          buttonTitle={`You have received ${item?.transporter_list_count
                              ? item.transporter_list_count
                              : 0
                            } Quotation`}
                          buttonLabel={
                            <div className="d-flex align-items-center">
                              <i
                                style={{ color: "white", fontSize: "14px" }}
                                className={`fa ${item?.status?.enquiry_closed === true &&
                                    item?.status?.approved_status === true
                                    ? "fa-certificate"
                                    : item?.status?.enquiry_closed === true &&
                                      item?.status?.approved_status === false
                                      ? "fa-exclamation-circle"
                                      : "fa-list-alt"
                                  }`}
                              />
                              <span style={{ marginLeft: "6px" }}>Quotation Summary</span>
                              {item?.transporter_list_count > 0 && (
                                <div className="ml-2">
                                  {item.transporter_list_count}
                                </div>
                              )}
                            </div>
                          }
                          style={{
                            fontSize: "13px",
                            cursor: isRestricted ? "not-allowed" : "pointer",
                            opacity: isRestricted ? 0.6 : 1,
                          }}
                        />
                      )}
                    </div>
                    <div style={{ fontSize: "13px" }}>
                      {ischat ? (
                        <Modal
                          buttonLabel={
                            <>
                              <i
                                style={{ color: "white", padding: "0 2%" }}
                                className="fa fa-comments-o"
                              />
                              Send Message
                            </>
                          }
                          buttonClass={`btn btn-sm ${resdata?.find(
                            (data) =>
                              data.truck_enquiry_id ===
                              item.truck_enquiry_id,
                          )?.transporter_unread_count !== 0 &&
                              resdata?.find(
                                (data) =>
                                  data.truck_enquiry_id ===
                                  item.truck_enquiry_id,
                              )?.transporter_unread_count !== undefined
                              ? "btn-success"
                              : "btn-primary"
                            }`}
                          //style={{ fontSize: "13px" }}
                          content={
                            <ViewEnquiry
                              item={item}
                              truck_enquiry_id={item.truck_enquiry_id}
                              type={"trucks"}
                            />
                          }
                          title={
                            <div style={{ display: "flex", alignItems: "center", gap: "6px", flexWrap: "wrap" }}>
                              <span title={item.lane_details?.origin?.location_name} style={{ display: "inline-flex", alignItems: "center", gap: "4px", background: "#f0f4ff", border: "1px solid #c7d2f5", borderRadius: "6px", padding: "3px 9px", fontSize: "12px", color: "#393185", fontWeight: 600 }}>
                                <i className="fa fa-circle" style={{ fontSize: "7px", color: "#393185" }} />
                                {item.lane_details?.origin?.location?.location || item.lane_details?.origin?.location_name?.split(',')[0]}
                              </span>
                              <i className="fa fa-long-arrow-right" style={{ color: "#393185", fontSize: "14px" }} />
                              <span title={item.lane_details?.destination?.location_name} style={{ display: "inline-flex", alignItems: "center", gap: "4px", background: "#f0f4ff", border: "1px solid #c7d2f5", borderRadius: "6px", padding: "3px 9px", fontSize: "12px", color: "#393185", fontWeight: 600 }}>
                                <i className="fa fa-map-marker" style={{ fontSize: "11px", color: "#e53935" }} />
                                {item.lane_details?.destination?.location?.location || item.lane_details?.destination?.location_name?.split(',')[0]}
                              </span>
                              <span style={{ display: "inline-flex", alignItems: "center", gap: "5px", background: "#393185", borderRadius: "6px", padding: "3px 10px", fontSize: "12px", color: "#fff", fontWeight: 500 }}>
                                <i className="fa fa-truck" style={{ fontSize: "11px" }} />
                                {Array.isArray(item.lane_details?.truck_types)
                                  ? item.lane_details?.truck_types.map((t) => t?.label).join(", ")
                                  : item.lane_details?.truck_types?.label}
                              </span>
                            </div>
                          }
                          disabled={(!isSuperAdmin && item.email !== company_mail) || isRestricted}
                          onClose={() => {
                            reload_data(filtered_details);
                          }}
                          id="chatenquiry"
                          screenName="LoRRI Spot"
                          moduleName="My Enquiries"
                          activityName={`Chat button clicked for ${item.lane_details?.origin.location_name} to ${item.lane_details?.destination.location_name}`}
                          onClick={
                            isRestricted
                              ? () => checkActionPermission("update")
                              : null
                          }
                          style={{
                            fontSize: "13px",
                            cursor: isRestricted ? "not-allowed" : "pointer",
                            opacity: isRestricted ? 0.6 : 1,
                          }}
                        />
                      ) : (
                        <UpgradeModal
                          screenName="LoRRI Spot"
                          moduleName="Upgrade Popup"
                          feature="Chat"
                          activityName={`Chat button clicked for ${item.lane_details?.origin.location_name} to ${item.lane_details?.destination.location_name}`}
                          buttonClass="btn btn-sm btn-primary"
                          buttonLabel={
                            <i
                              style={{ color: "white" }}
                              className="fa fa-comments-o"
                            />
                          }
                        />
                      )}
                    </div>
                  </div>
                  <div className={classes["mobile-button-row"]}>
                    {isCancelled && (
                      <Modal
                        buttonLabel={
                          <>
                            <span
                              className="btn btn-sm btn-link"
                              data-tip
                              data-for={`remark${index}`}
                            >
                              View Remark for Cancellation
                            </span>
                            <ReactTooltip
                              id={`remark${index}`}
                              className={`${classes["tooltip"]}`}
                              place="bottom"
                              effect="solid"
                              scrollHide={true} delayHide={0}
                            >
                              {item.cancel_reason &&
                                item.cancel_reason.length > 25
                                ? `${item.cancel_reason.substring(
                                  0,
                                  20
                                )}...`
                                : item.cancel_reason}
                            </ReactTooltip>
                          </>
                        }
                        buttonClass="btn btn-sm btn-link"
                        content={<span>{item.cancel_reason}</span>}
                        title={`Remarks`}
                        screenName="LoRRI Spot"
                        moduleName="My Enquiry"
                        activityName={`View Remark clicked for ${item.lane_details?.origin.location_name} to ${item.lane_details?.destination.location_name}`}
                      />
                    )}

                    {(isActive || isApproved) && (
                      <>
                        {isIndent ? (
                          <Modal
                            disabled={(!isApprover && !item.move_to_indent)}
                            buttonLabel={
                              <i
                                className="fa fa-share-square"
                                data-tip
                                data-for={`move_to_indent${index}`}
                              />
                            }
                            buttonClass={`btn btn-sm btn-primary ${classes["action-buttons"]}`}
                            content={
                              <MoveToIndent
                                item={item}
                                truck_enquiry_id={index}
                                transporter_list={item.transporter_list}
                                send_data={send_data}
                                setsenddata={setsend_data}
                                companyProfile={companyProfileData}
                              />
                            }
                            title={`Move to LoRRI Indent`}
                            id="closebutton"
                            screenName="LoRRI Spot"
                            moduleName="My Enquiries"
                            activityName={`Move to LoRRI Indent clicked for ${item.lane_details?.origin.location_name} to ${item.lane_details?.destination.location_name}`}
                            onClose={closeIndentModal}
                            style={{ fontSize: "13px" }}
                          />
                        ) : (
                          <span style={{ marginRight: "5%" }}>
                            <UpgradeModal
                              screenName="LoRRI Spot"
                              moduleName="Upgrade Popup"
                              feature="Move to Indents"
                              activityName={`Move to LoRRI Indent clicked for ${item.lane_details?.origin.location_name} to ${item.lane_details?.destination.location_name}`}
                              buttonClass="btn btn-sm btn-primary"
                              buttonTitle={`Move to Indents`}
                              buttonLabel={
                                <i
                                  className="fa fa-share-square"
                                  data-tip
                                  data-for={`move_to_indent${index}`}
                                />
                              }
                            />
                          </span>
                        )}
                        <ReactTooltip
                          id={`move_to_indent${index}`}
                          className={`${classes["tooltip"]}`}
                          place="bottom"
                          effect="solid"
                          scrollHide={true} delayHide={0}
                        >
                          Move to Indent
                        </ReactTooltip>
                      </>
                    )}

                    {isActive && (
                      <>
                        <Modal
                          disabled={
                            (!isSuperAdmin &&
                              item.email !== company_mail) ||
                            isRestricted
                          }
                          buttonLabel={
                            <>
                              <i
                                className="fa fa-pencil"
                                data-tip
                                data-for={`edit_enquiry${index}`}
                                style={{ padding: "0 1%" }}
                              />{" "}
                              Click Here to Edit
                            </>
                          }
                          buttonClass={`btn btn-sm btn-link ${classes["action-buttons"]}`}
                          //style={{ color: "#393186" }}
                          content={
                            <EditEnquiry
                              TruckTypes={TruckTypes}
                              tenurelist={tenurelist}
                              truck_enquiry_id={item.truck_enquiry_id}
                              getEnquiries={(e) => getEnquiries("active")}
                              item={item}
                              profile_view_allowed={profile_view_allowed}
                              profile_view_count={profile_view_count}
                              isSuperAdmin={isSuperAdmin}
                            />
                          }
                          title={`Edit Enquiry`}
                          subtitle={
                            <div style={{ display: "flex", flexDirection: "column", gap: "6px", marginTop: "2px" }}>
                              {/* Route row */}
                              <div style={{ display: "flex", alignItems: "center", gap: "6px", flexWrap: "wrap" }}>
                                <span style={{ display: "inline-flex", alignItems: "center", gap: "4px", background: "#f0f4ff", border: "1px solid #c7d2f5", borderRadius: "6px", padding: "3px 9px", fontSize: "12px", color: "#393185", fontWeight: 600 }}>
                                  <i className="fa fa-circle" style={{ fontSize: "7px", color: "#393185" }} />
                                  {item.lane_details?.origin.location_name}
                                </span>
                                <i className="fa fa-long-arrow-right" style={{ color: "#393185", fontSize: "14px" }} />
                                <span style={{ display: "inline-flex", alignItems: "center", gap: "4px", background: "#f0f4ff", border: "1px solid #c7d2f5", borderRadius: "6px", padding: "3px 9px", fontSize: "12px", color: "#393185", fontWeight: 600 }}>
                                  <i className="fa fa-map-marker" style={{ fontSize: "11px", color: "#e53935" }} />
                                  {item.lane_details?.destination.location_name}
                                </span>
                              </div>
                              {/* Truck type row */}
                              <div>
                                <span style={{ display: "inline-flex", alignItems: "center", gap: "5px", background: "#393185", borderRadius: "6px", padding: "3px 10px", fontSize: "12px", color: "#fff", fontWeight: 500 }}>
                                  <i className="fa fa-truck" style={{ fontSize: "11px" }} />
                                  {Array.isArray(item.lane_details?.truck_types)
                                    ? item.lane_details?.truck_types.map((t) => t.label).join(", ")
                                    : item.lane_details?.truck_types?.label}
                                </span>
                              </div>
                            </div>
                          }
                          id="editenquiry"
                          size="md"
                          screenName="LoRRI Spot"
                          moduleName="My Enquiries"
                          activityName={`Edit Enquiry Button clicked for ${item.lane_details?.origin.location_name} to ${item.lane_details?.destination.location_name}`}
                          onClick={
                            isRestricted
                              ? () => checkActionPermission("update")
                              : null
                          }
                          style={{
                            color: "#393186",
                            cursor: isRestricted
                              ? "not-allowed"
                              : "pointer",
                            opacity: isRestricted ? 0.6 : 1,
                          }}
                        />
                        <ReactTooltip
                          id={`edit_enquiry${index}`}
                          className={`${classes["tooltip"]}`}
                          place="bottom"
                          effect="solid"
                          scrollHide={true} delayHide={0}
                        >
                          Edit Enquiry
                        </ReactTooltip>
                        <Modal
                          disabled={(!isSuperAdmin && item.email !== company_mail) || isRestricted}
                          buttonLabel={
                            <>
                              <i
                                className="fa fa-close"
                                data-tip
                                data-for={`cancel_enquiry${index}`}
                                style={{ padding: "0 3%" }}
                              />
                              Cancel Enquiry
                            </>
                          }
                          buttonClass={`btn btn-sm btn-primary ${classes["action-buttons"]}`}
                          content={
                            <CancelEnquiry
                              item={item}
                              apply_Filter={apply_Filter}
                              filters_applied={filters_applied}
                              visible_enquiry={visible_enquiry}
                              skipactive={skipactive}
                            />
                          }
                          title={
                            <div>
                              <div style={{ display: "flex", alignItems: "center", gap: "6px", flexWrap: "wrap", marginTop: "2px" }}>
                                <span title={item.lane_details?.origin?.location_name} style={{ display: "inline-flex", alignItems: "center", gap: "4px", background: "#f0f4ff", border: "1px solid #c7d2f5", borderRadius: "6px", padding: "3px 9px", fontSize: "12px", color: "#393185", fontWeight: 600 }}>
                                  <i className="fa fa-circle" style={{ fontSize: "7px", color: "#393185" }} />
                                  {item.lane_details?.origin?.location?.location || item.lane_details?.origin?.location_name?.split(',')[0]}
                                </span>
                                <i className="fa fa-long-arrow-right" style={{ color: "#393185", fontSize: "14px" }} />
                                <span title={item.lane_details?.destination?.location_name} style={{ display: "inline-flex", alignItems: "center", gap: "4px", background: "#f0f4ff", border: "1px solid #c7d2f5", borderRadius: "6px", padding: "3px 9px", fontSize: "12px", color: "#393185", fontWeight: 600 }}>
                                  <i className="fa fa-map-marker" style={{ fontSize: "11px", color: "#e53935" }} />
                                  {item.lane_details?.destination?.location?.location || item.lane_details?.destination?.location_name?.split(',')[0]}
                                </span>
                              </div>
                              <div style={{ marginTop: "6px" }}>
                                <span style={{ display: "inline-flex", alignItems: "center", gap: "5px", background: "#393185", borderRadius: "6px", padding: "3px 10px", fontSize: "12px", color: "#fff", fontWeight: 500 }}>
                                  <i className="fa fa-truck" style={{ fontSize: "11px" }} />
                                  {Array.isArray(item.lane_details?.truck_types)
                                    ? item.lane_details?.truck_types.map((t) => t?.label).join(", ")
                                    : item.lane_details?.truck_types?.label}
                                </span>
                              </div>
                              <div style={{ marginTop: "6px" }}>Cancel this enquiry</div>
                            </div>
                          }
                          id="cancelenquiry"
                          size="md"
                          screenName="LoRRI Spot"
                          moduleName="My Enquiries"
                          activityName={`Cancel Enquiry Button clicked for ${item.lane_details?.origin.location_name} to ${item.lane_details?.destination.location_name}`}
                          onClick={
                            isRestricted
                              ? () => checkActionPermission("update")
                              : null
                          }
                          style={{
                            cursor: isRestricted
                              ? "not-allowed"
                              : "pointer",
                            opacity: isRestricted ? 0.6 : 1,
                            width: "130px",
                          }}
                        />
                        <ReactTooltip
                          id={`cancel_enquiry${index}`}
                          className={`${classes["tooltip"]}`}
                          place="bottom"
                          effect="solid"
                          scrollHide={true} delayHide={0}
                        >
                          Cancel Enquiry
                        </ReactTooltip>
                      </>
                    )}

                    {isArchived && (
                      <span
                        className="font-italic text-muted"
                        data-tip
                        data-for={`expired${index}`}
                      >
                        This Enquiry is archived
                        <ReactTooltip
                          id={`expired${index}`}
                          className={`${classes["tooltip"]}`}
                          place="bottom"
                          effect="solid"
                          scrollHide={true} delayHide={0}
                        >
                          This Enquiry is archived
                        </ReactTooltip>
                      </span>
                    )}
                  </div>

                  <div style={{ display: "flex", padding: "5%" }}>
                    <div>
                      <b>Placement Details:</b>
                    </div>
                    {isPlacement ? (
                      <Modal
                        buttonLabel={<>Click Here</>}
                        style={{ padding: "0" }}
                        buttonClass={`btn btn-sm btn-link`}
                        content={({ onClose }) => (
                          <NewPlacementDetails
                            getEnquiryApis={getEnquiryApis}
                            setNewSpot={setNewSpot}
                            newSpot={newSpot}
                            enquiryBucket={enquiryBucket}
                            item={item}
                            truck_enquiry_id={index}
                            send_data={send_data}
                            setsenddata={setsend_data}
                            planningbutton={planningbutton}
                            company_id={company_id}
                            backbutton={backbutton}
                            discovernowbutton={discovernowbutton}
                            onClose={onClose}
                            editmode={isActive}
                          />
                        )}
                        title={`Placement Details`}
                        id="closebutton-planning"
                        size="lg"
                        screenName="LoRRI Spot"
                        moduleName="My Enquiries"
                        activityName={`View Placement Details clicked for ${item.lane_details?.origin.location_name} to ${item.lane_details?.destination.location_name}`}
                      />
                    ) : (
                      <UpgradeModal
                        screenName="LoRRI Spot"
                        moduleName="Upgrade Popup"
                        feature="View Placement Details"
                        activityName={`Placement Details button clicked for ${item.lane_details?.origin.location_name} to ${item.lane_details?.destination.location_name}`}
                        buttonClass="btn btn-sm btn-primary"
                        buttonTitle={`Placement Details`}
                        buttonLabel={
                          <i
                            className="fa fa-list-alt"
                            data-tip
                            data-for={`placement_details${index}`}
                          />
                        }
                      />
                    )}
                  </div>
                </div>
              );
            })
          ) : filtered_details.length === 0 && send_data.length === 0 ? (
            <div className={classes["mobile-enquiry"]}>
              <span>
                No{" "}
                {expiredEnquiries
                  ? "Archived"
                  : approveEnquiry
                    ? "Approved"
                    : cancelEnquiry
                      ? "Cancelled"
                      : "Active"}{" "}
                Enquiries found.
                <br />
                Please Add Origin, Destination and Truck Type to float an
                enquiry
              </span>
            </div>
          ) : null}
        </div>
      }
      <ControlledModal
        isOpen={showTenureUpgradeModal}
        onClose={() => setShowTenureUpgradeModal(false)}
        content={<TenurePremiumModal />}
        title="Premium Plan Required"
        backdrop={true}
        size="md"
      />
    </>
  );
};

export default MobileAddedLanes;
